"use client"
import React, { useEffect } from "react"
import Prism from "prismjs"
import "prismjs/components/prism-typescript"
import "prismjs/components/prism-python"
import "prismjs/components/prism-r"
import "prismjs/components/prism-bash"

interface CodeBlockProps {
    code: string
    language: string
}

export default function CodeBlock({ code, language }: CodeBlockProps) {
    useEffect(() => {
        Prism.highlightAll()
    }, [])

    return (
        <pre
            className={`language-${language} mt-2 overflow-auto rounded bg-gray-100 p-4 text-sm text-gray-800 dark:bg-zinc-800 dark:text-gray-200`}
        >
            <code className={`language-${language}`}>{code}</code>
        </pre>
    )
}
